//@flow
import * as React from 'react'
import type { RheaQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const RheaQualityReview=(props:RheaQualityReview$Props)=>{
    const rhea = props.rhea
    let isVisible = false

    if (rhea.reviewQuestions && rhea.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'orionQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'orionPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(rhea.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default RheaQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectRhea/RheaQualityReview.js